// extracted by mini-css-extract-plugin
export var button = "_5y-4";
export var hasDarkBackground = "_5y-7";
export var hasLightBackground = "_5y-6";
export var iconWrapper = "_5y-0";
export var large = "_5y-2";
export var medium = "_5y-1";
export var small = "_5y-5";
export var xsmall = "_5y-3";